import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  PaymentInitiatedResponse,
  PaymentStatusResponse,
} from "../../types/payment";

interface PaymentState {
  initiating: boolean;
  initiateError: string | null;
  initiated: PaymentInitiatedResponse | null;
  statusLoading: boolean;
  statusError: string | null;
  status: PaymentStatusResponse | null;
}

const initialState: PaymentState = {
  initiating: false,
  initiateError: null,
  initiated: null,
  statusLoading: false,
  statusError: null,
  status: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetPayment: () => initialState,
    setInitiating(state, action: PayloadAction<boolean>) {
      state.initiating = action.payload;
      if (action.payload) state.initiateError = null;
    },
    setInitiateError(state, action: PayloadAction<string | null>) {
      state.initiating = false;
      state.initiateError = action.payload;
    },
    setInitiated(
      state,
      action: PayloadAction<PaymentInitiatedResponse | null>
    ) {
      state.initiating = false;
      state.initiated = action.payload;
    },
    setStatusLoading(state, action: PayloadAction<boolean>) {
      state.statusLoading = action.payload;
      if (action.payload) state.statusError = null;
    },
    setStatusError(state, action: PayloadAction<string | null>) {
      state.statusLoading = false;
      state.statusError = action.payload;
    },
    setStatus(state, action: PayloadAction<PaymentStatusResponse | null>) {
      state.statusLoading = false;
      state.status = action.payload;
    },
  },
});

export const {
  resetPayment,
  setInitiating,
  setInitiateError,
  setInitiated,
  setStatusLoading,
  setStatusError,
  setStatus,
} = paymentSlice.actions;

export const selectPaymentState = (state: { payment: PaymentState }) =>
  state.payment;

export default paymentSlice.reducer;
